/* unplugin-vue-components disabled */import script from "./rAIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./rAIndex.vue?vue&type=script&setup=true&lang=js"

import "./rAIndex.vue?vue&type=style&index=0&id=18bbe5c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18bbe5c8"]])

export default __exports__